module.exports = __webpack_public_path__ + "static/media/notelehealthservicesicon.cb6a873b.svg";